import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { DesignAngularKitModule } from 'design-angular-kit';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isLoggedIn = false;

  constructor(
    private keycloak: KeycloakService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    const instance = this.keycloak.getKeycloakInstance();
    this.isLoggedIn = !!(instance?.authenticated);
  }

  login() {
    this.keycloak.login({
      redirectUri: window.location.origin + '/dashboard'
    });
  }
}
